import ErrorPageTemplate from '../../components/ErrorPageTemplate';
import { useLanguage } from '../../contexts/language';

const NotFoundPage = () => {
  const { t } = useLanguage();
  return (
    <ErrorPageTemplate
      errorText={t('error-pages.not-found.text')}
      description={t('error-pages.not-found.description')}
    />
  );
};


export default NotFoundPage;